export default __webpack_public_path__ + "static/media/mines.d794b727.jpg";